import { useState} from "react";
import {getComponentById} from "../../services/Administrative/componentService";

export const useGetComponentById = () => {
    const [component, setComponent] = useState<any>(null);

    const fetchComponentById = async (id:number) => {
        try {
            const response:any = await getComponentById(id);
            setComponent(response.data.component);
        } catch (error) {
            console.error('Error fetching component');
        }
    }

    return { component, fetchComponentById };
};
